var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMediumIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.92634 18.1876C10.3376 18.1876 13.1029 15.3277 13.1029 11.8C13.1029 8.27229 10.3374 5.4126 6.92634 5.4126C3.51529 5.4126 0.75 8.27142 0.75 11.8C0.75 15.3286 3.51508 18.1876 6.92634 18.1876ZM16.7905 17.8128C18.4961 17.8128 19.8788 15.1209 19.8788 11.8C19.8788 8.47997 18.4961 5.78723 16.7905 5.78723C15.085 5.78723 13.7021 8.47997 13.7021 11.8C13.7021 15.1201 15.085 17.8128 16.7905 17.8128ZM22.6501 11.7999C22.6501 14.7753 22.1638 17.1871 21.5639 17.1871C20.9641 17.1871 20.4778 14.7744 20.4778 11.7999C20.4778 8.82542 20.9641 6.41272 21.5641 6.41272C22.1642 6.41272 22.6501 8.82477 22.6501 11.7999Z",
    fill: "#009BE0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumIcon);
export default __webpack_public_path__ + "static/media/MediumIcon.19bac335e484691174261e7154ea7808.svg";
export { ForwardRef as ReactComponent };